import {useQueryClient} from '@github-ui/react-query'
import {useOverviewRouteQueryKey} from '../data/use-overview-route-data'
import {useLayoutRouteQueryKey} from '../../../page-data/loaders/use-layout-route-data'

/** Invalidate queries tied to the current PR state (open/closed/draft), triggering refetches. */
export function useInvalidatePrState() {
  const queryClient = useQueryClient()
  const overviewQueryKey = useOverviewRouteQueryKey()
  const layoutQueryKey = useLayoutRouteQueryKey()

  return async () => {
    // We also need to invalidate the overview route because it owns the 'user' object with allowable state changes,
    // which unfortunately aren't pure permission checks; they depend on the current PR state
    await Promise.all([
      queryClient.invalidateQueries({queryKey: layoutQueryKey}),
      queryClient.invalidateQueries({queryKey: overviewQueryKey}),
    ])
  }
}
